import { render, staticRenderFns } from "./veStuMoralResource.vue?vue&type=template&id=480c6040&scoped=true"
import script from "./veStuMoralResource.vue?vue&type=script&lang=js"
export * from "./veStuMoralResource.vue?vue&type=script&lang=js"
import style0 from "./veStuMoralResource.vue?vue&type=style&index=0&id=480c6040&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480c6040",
  null
  
)

export default component.exports